<template>
  <div class="driving-report-warp">

    <a-col class="scheduleList_wrap">
      <div class="calendar_container">
        <img src="../../assets/icons/calendar.svg" alt=""/>
        <a-month-picker
            size="large"
            :locale="locale"
            format="YYYY-MM"
            suffix-icon=" "
            v-model="searchDate"
            @change="searchScheduleData"
            :disabled-date="disabledDate"
        />

      </div>

      <div v-if="!hasReport" class="no-report">當月無行駛報告</div>

      <div v-else>
        <div class="card">
          <h3>您本月展開了</h3>
          <div>
            <h4>
              {{
                (reportData.dayJourney + reportData.nightJourney)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
            </h4>
            <span>趟行程</span>
          </div>
          <footer>
            <div>
              <div>
                <span>日</span>
                <p>{{ reportData.dayJourney }}趟</p>
              </div>
              <div>
                <span>夜</span>
                <p>{{ reportData.nightJourney }}趟</p>
              </div>
            </div>
            <div>
              <div>
                <span>平均一天</span>
                <p>{{ reportData.avgJourney }}趟</p>
              </div>
              <div>
                <span>單日最多</span>
                <p>{{ reportData.maxJourney }}趟</p>
              </div>
            </div>
          </footer>
        </div>

        <div class="card">
          <h3>行駛距離</h3>
          <div>
            <h4>
              {{
                (reportData.dayDistance + reportData.nightDistance)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
            </h4>
            <span>公里</span>
          </div>
          <footer>
            <div>
              <div>
                <span>日</span>
                <p>{{ reportData.dayDistance }}公里</p>
              </div>
              <div>
                <span>夜</span>
                <p>{{ reportData.nightDistance }}公里</p>
              </div>
            </div>
            <div>
              <div>
                <span>平均一天</span>
                <p>{{ reportData.avgDistance }}公里</p>
              </div>
              <div>
                <span>單日最遠</span>
                <p>{{ reportData.maxDistance }}公里</p>
              </div>
            </div>
          </footer>
        </div>

        <div class="card">
          <h3>總計耗時</h3>
          <div>
            <h4>{{ maxTimeConsume()[0] }}</h4>
            <span>時</span>
            <h4>{{ maxTimeConsume()[1] }}</h4>
            <span>分</span>
          </div>
          <footer>
            <div>
              <div>
                <span>日</span>
                <p>{{ convertToHHmm(reportData.dayTimeConsume) }}</p>
              </div>
              <div>
                <span>夜</span>
                <p>{{ convertToHHmm(reportData.nightTimeConsume) }}</p>
              </div>
            </div>
            <div>
              <div>
                <span>平均一天</span>
                <p>{{ convertToHHmm(reportData.avgTimeConsume) }}</p>
              </div>
              <div>
                <span>單日最久</span>
                <p>{{ convertToHHmm(reportData.maxTimeConsume) }}</p>
              </div>
            </div>
          </footer>
        </div>

        <div class="card">
          <h3>油量總耗費</h3>
          <div>
            <h4>
              {{
                (reportData.dayFuelConsume + reportData.nightFuelConsume)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
            </h4>
            <span>公升</span>
          </div>
          <footer>
            <div>
              <div>
                <span>日</span>
                <p>{{ reportData.dayFuelConsume }}公升</p>
              </div>
              <div>
                <span>夜</span>
                <p>{{ reportData.nightFuelConsume }}公升</p>
              </div>
            </div>
            <div>
              <div>
                <span>平均一天</span>
                <p>{{ reportData.avgFuelConsume }}公升</p>
              </div>
              <div>
                <span>單日最耗油</span>
                <p>{{ reportData.maxFuelConsume }}公升</p>
              </div>
            </div>
          </footer>
        </div>
        <div style="text-align: center">
          <span
          >以上數據自{{ reportData.startOfDate }}統計至{{
              reportData.asOfDate
            }}</span
          >
        </div>
      </div>
    </a-col>

  </div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_TW";
import {mapState} from "vuex";
import {drivingReportApi, deviceInfoApi} from "../../api/api";
import moment from "moment";

export default {
  name: "DrivingReport",
  data() {
    return {
      locale,
      searchDate: this.$moment(),
      scheduleData: [],
      openedTs: "",
      expiredTs: "",
      isTbox: false,
      msgObj: {
        visible: false,
        title: "",
        okText: "確認",
        cancelText: "",
        detailText: "",
        msgClass: "msg_confirm_modal",
      },
      hasReport: true,
      reportData: {
        dayJourney: 0,
        nightJourney: 0,
        maxJourney: 0,
        dayDistance: 0,
        nightDistance: 0,
        maxDistance: 0,
        dayTimeConsume: 0,
        nightTimeConsume: 0,
        maxTimeConsume: 0,
        dayFuelConsume: 0,
        nightFuelConsume: 0,
        maxFuelConsume: 0,
        avgJourney: 0,
        avgDistance: 0,
        avgTimeConsume: 0,
        avgFuelConsume: 0,
        startOfDate: "YYYY-MM-DD",
        asOfDate: "YYYY-MM-DD",
      },
      enabledCode: "",
      fleetCode: "",
    };
  },
  async mounted() {
    const params = {
      // deviceUid: this.$route.query.data,
      encodedImei: this.$route.query.data,
    };
    try {
      const info = await deviceInfoApi(params);
      const {enabledCode, fleetCode} = info.data;
      this.fleetCode = fleetCode;
      this.enabledCode = enabledCode;
      this.getDrivingReport();
    } catch (e) {
      this.$emit('responseStatus', {...this.msgObj, visible: true, title: "發生錯誤"});
    }

  },
  methods: {
    hideModal() {
    },
    async getDrivingReport() {
      const params = {
        enabledCode: this.enabledCode,
        fleetCode: this.fleetCode,
        drivingMonth: this.searchDate.format("YYYYMM"),
      };
      try {
        const result = await drivingReportApi(params);
        const {status, data} = result;

        if (status !== 200) {
          this.hasReport = false;
          // this.$emit('responseStatus', {...this.msgObj, visible: true, title: "此車隊當月暫無資料"});
        } else {
          this.hasReport = true;
          this.reportData = data;
        }
      } catch (e) {
        this.hasReport = false;
        // this.$emit('responseStatus', {...this.msgObj, visible: true, title: "此車隊當月暫無資料"});
      }
    },

    convertToHHmm(hours) {
      const formattedTime = moment.utc(hours * 60 * 60 * 1000).format("HH:mm");
      return formattedTime.split(":").join("時") + "分";
    },

    maxTimeConsume() {
      const maxTime =
          this.reportData.dayTimeConsume + this.reportData.nightTimeConsume;
      const formattedTime = moment
          .utc(maxTime * 60 * 60 * 1000)
          .format("HH:mm");
      return formattedTime.split(":");
    },

    searchScheduleData(e) {
      console.log(e);
      this.getDrivingReport();
    },
    disabledDate(current) {
      return current && current > moment().endOf('day');
    }
  },
  computed: {
    ...mapState("identidyOpenResult", ["openResult"]),
    ...mapState("identidyOpenStatus", ["deviceUid"]),
    ...mapState("todayScheduleList", ["scheduleList"]),
    // ...mapState('todayScheduleList', ['tempDate']),
    sortedScheduleData() {
      console.log("sortedList", [...this.scheduleData]);
      return [...this.scheduleData];
    }
  },
};
</script>

<style lang="scss" scoped>
.driving-report-warp {
  padding: 12px;
}

.scheduleList_wrap {
  top: 45px;
  margin-bottom: 20px;
}

.calendar_container {
  position: relative;
  margin-bottom: 20px;

  img {
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }
}

.card {
  border: 1px solid rgba(19, 34, 149, 0.1);
  padding: 12px;
  border-radius: 8px;

  h4 {
    font-weight: 700;
    font-size: 34px;
    line-height: 48px;
    margin-right: 10px;
    margin-bottom: 0px;
    display: inline;
  }

  > div {
    text-align: center;
    margin-bottom: 20px;

    span {
      margin-right: 10px;
    }
  }

  & + div {
    margin-top: 20px;
  }
}

footer {
  overflow: hidden;

  > div {
    width: 50%;
    float: left;
    padding: 0px 30px 0px 4px;

    > div {
      float: left;
      width: 100%;

      > span {
        color: #999999;
        margin-right: 5px;
        float: left;

        font-size: 14px;
        line-height: 24px;
      }

      > p {
        color: #343741;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        float: right;
      }
    }

    & + div {
      border-left: 1px solid rgba(19, 34, 149, 0.1);
      padding: 0px 4px 0px 30px;
    }
  }
}

.no-report {
  margin-top: 60px;
  color: #999999;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  height: 500px;
  //align-items: center;
  justify-content: center;
}
</style>
